{
  "favoriteBoardmakerSoftware": "favorite Boardmaker software",
  "planDetailsStartTrial": "Start your free trial today which includes access for 30 days!",
  "community": {
    "summary": "Take advantage of ready-made accessible educational materials shared by parents, educators and therapists like you! Save time by searching and filtering activities and templates, then simply add them to your account and you are ready to edit and use with your favorite Boardmaker software. With 60,000 FREE print and interactive activities and over 500,000 members, what are you waiting for?",
    "topReasons": {
      "header": "Top reasons to sign up for Boardmaker Community",
      "points": [
        "Share great activities that you have created",
        "Use powerful search features to find exactly what you need",
        "Find activities professionally created by the Boardmaker Education Team",
        "Search for activities aligned to Common Core standards",
        "Join groups that are specific to your interests"
      ]
    },
    "summaryEnd": "Share and explore interactive and print materials that provide behavior supports and promote student independence as well as skill development, all for FREE.",
    "features": [
      {
        "featureTitle": "Find",
        "featureDescription": "Discover adapted curriculum, visual schedules, communication boards, education standards-aligned activities, and other supports that have been developed and used by parents, therapists and educators."
      },
      {
        "featureTitle": "Share",
        "featureDescription": "Upload activities you have created, participate in discussions, establish public and private groups for sharing, and so much more."
      },
      {
        "featureTitle": "Use",
        "featureDescription": "Store your activities online and access them from any computer."
      },
      {
        "featureTitle": "Connect",
        "featureDescription": "Connect with others who are teaching the same subject or grade level, exchange ideas with parents facing the same challenges as you, and share solutions you have created."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 or later"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 or later"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 or later"]
      ],
      "browser": [
        ["Chrome", "v49.0", "current"],
        ["Firefox", "v38.0", "current"],
        ["Safari", "v11.0", "current"],
        ["Edge", "v83.0.478.45", "current"],
        ["Internet Explorer", "v10.0", "v11.0 or later"]
      ]
    }
  },
  "personal": {
    "summary": "Bring the power of Boardmaker into your home with ease. A Boardmaker Personal subscription gives you the capability to take an active role in your child’s success by providing consistency between home, school and therapy, an option to extend learning beyond the school day and even the school year. Network with other parents in the Boardmaker Community to share your creations and get ideas for many more.",
    "topReasons": {
      "header": "Top reasons to sign up for Boardmaker Personal",
      "points": [
        "Bring engaging and interactive activities to any computer or iPad",
        "Print activities whenever you need them",
        "As a parent, take an active role in your child’s learning at home",
        "Take fun and engaging materials wherever you need to go and create or edit activities from any computer"
      ]
    },
    "summaryEnd": "Start your free trial today which includes full access for 30 days!",
    "features": [
      {
        "featureTitle": "Create and Edit",
        "featureDescription": "Create and edit symbol-adapted activities, like visual schedules for planning out your day, individualized books and learning materials, and behavioral supports! With a library of over 80,000+ symbols to choose from, the possibilities are endless. Need more? Use our web search option to bring any media files into your project."
      },
      {
        "featureTitle": "Print and Play",
        "featureDescription": "Print your own activities, or any you find on the Boardmaker Community, right from your web browser to use with your child. Looking to increase engagement? Try our interactive templates and activities. Children and parents can easily play activities through the free Student Center app on their tablet or communication device."
      },
      {
        "featureTitle": "Teach and Extend",
        "featureDescription": "Jumpstart your child’s language and literacy skills with access to our three easy-to-use curriculum programs. Start with Core First Learning – a tool to help your child learn the meaning, use and placement of high frequency core words. Ideal for individuals using core-based augmentative communication systems or those that are learning how to read! Apply these new skills to grade level literature by engaging with Book Bridge, and then start to build world knowledge through the exploration of history, geography, life and culture with Expedition Education."
      },
      {
        "featureTitle": "Find and Share",
        "featureDescription": "Why recreate the wheel? Choose from over 60,000 FREE ready-made print and interactive activities and 1,100 categorized public groups in the Boardmaker Community - the largest sharing community of its kind in the world. You can also upload activities you've created to your Boardmaker Community account and share them with parents, therapists, or your learner's support team."
      },
      {
        "featureTitle": "Monitor and Track",
        "featureDescription": "Monitor and track your child’s progress as they work on activities to ensure their success and help you determine the most effective approach."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 or later"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 or later"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 or later"]
      ],
      "browser": [
        ["Chrome", "v49.0", "current"],
        ["Firefox", "v38.0", "current"],
        ["Safari", "v11.0", "current"],
        ["Edge", "v83.0.478.45", "current"],
        ["Internet Explorer", "v10.0", "v11.0 or later"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Professional is the most complete system for Special Education Teachers, Speech & Language Pathologists, Occupational Therapists, Behavioral Therapists and more to find, create, organize, and deliver customized visual supports, symbol-based communication and therapy activities that address the needs for the students in your classroom or on your caseload.",
    "topReasons": {
      "header": "Top reasons to sign up for Boardmaker Professional",
      "points": [
        "Manage and assign student activities from anywhere and on any computer",
        "Use the large library of standards-aligned sample activities or create your own",
        "Students can access instructional activities from any computer or iPad at school or at home",
        "Collect data and track student progress towards IEP goals and educational standards",
        "Built-in tools help you collaborate and share with other team members"
      ]
    },
    "summaryEnd": "Start your free trial today which includes full access for 30 days!",
    "features": [
      {
        "featureTitle": "Create and Edit",
        "featureDescription": "Create and edit symbol-adapted activities, like visual schedules for planning out your day, individualized books and learning materials, and behavioral supports! With a library of over 80,000+ symbols to choose from, the possibilities are endless. Need more? Use our web search option to bring any media files into your project."
      },
      {
        "featureTitle": "Print and Play",
        "featureDescription": "Print your own activities, or any you find on the Boardmaker Community, right from your web browser to use with your child. Looking to increase engagement? Try our interactive templates and activities. Children and parents can easily play activities through the free Student Center app on their tablet or communication device."
      },
      {
        "featureTitle": "Teach and Extend",
        "featureDescription": "Help your learner take the next step in their education journey with access to three robust, standards-aligned curriculum programs. Included with your Boardmaker Subscription, Boardmaker Instructional Solutions comes with over 140 step-by-step lesson plans, more than 1500 differentiated and standards-aligned activities, 300+ printable and accessible books, classroom management tools, quizzes, games, recipes, crafts, and more!"
      },
      {
        "featureTitle": "Find and Share",
        "featureDescription": "Why recreate the wheel? Choose from over 60,000 FREE ready-made print and interactive activities and 1,100 categorized public groups in the Boardmaker Community - the largest sharing community of its kind in the world. You can also upload activities you've created to your Boardmaker Community account and share them with parents, therapists, or your learner's support team."
      },
      {
        "featureTitle": "Monitor and Track",
        "featureDescription": "Monitor and track your child’s progress as they work on activities to ensure their success and help you determine the most effective approach."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 or later"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 or later"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 or later"]
      ],
      "browser": [
        ["Chrome", "v49.0", "current"],
        ["Firefox", "v38.0", "current"],
        ["Safari", "v11.0", "current"],
        ["Edge", "v83.0.478.45", "current"],
        ["Internet Explorer", "v10.0", "v11.0 or later"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Organization supports your multidisciplinary team by delivering adapted activities, behavioral supports, and measurement of progress toward standards and goals. \n\nThe Boardmaker cloud-based system provides a framework for consistency and collaboration across the entire organization and allows staff to work from anywhere. Plus, it gives them access to a library of over 60,000 premade activities, three full curriculum programs, and more than 80,000 Picture Communication Symbols to jumpstart their lesson planning. Now your staff can quickly deliver print and interactive activities to their students or clients using the Boardmaker Student Center to extend learning and therapy, all with the click of a button!\n\nSee staff usage and improve efficiency across your organization with the power to manage accounts and data centrally, along with advanced sharing and collaboration tools.",
    "topReasons": {
      "header": "Top reasons to sign up for Boardmaker Organization",
      "points": [
        "Cloud-based system provides consistency and collaboration across entire organization and allows staff to work from anywhere",
        "Extensive library of sample activities already aligned to College and Career Readiness Standards and your state specific standards",
        "Students can access instructional activities from any computer, anywhere",
        "Activities can be associated with IEP goals to demonstrate student achievement",
        "Immediate access to student performance data and staff usage, all from one system"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Create and Edit",
        "featureDescription": "Create and edit symbol-adapted activities, like visual schedules for planning out your day, individualized books and learning materials, and behavioral supports! With a library of over 80,000+ symbols to choose from, the possibilities are endless. Need more? Use our web search option to bring any media files into your project."
      },
      {
        "featureTitle": "Print and Play",
        "featureDescription": "Print your own activities, or any you find on the Boardmaker Community, right from their web browser. Looking to increase engagement? Encourage your team to try our interactive templates and activities. Students can easily play activities through the free, fully accessible Student Center app with no internet connection necessary."
      },
      {
        "featureTitle": "Teach and Extend",
        "featureDescription": "Give your staff access to three robust, standards-aligned curriculum programs, all included with your Boardmaker Organization Subscription. Boardmaker Instructional Solutions comes with over 140 step-by-step lesson plans, more than 1500 differentiated and standards-aligned activities, 300+ printable and accessible books, classroom management tools quizzes, games, recipes, crafts, and more!"
      },
      {
        "featureTitle": "Assign and Track",
        "featureDescription": "With a Boardmaker Organization Account, staff can assign customized and leveled activities for students to track their individual progress against their IEP goals and state and local standards. They can then use our Progress Monitoring tool to quickly reference their students’ performance and report easily on their success. Assigned activities completed at home are also tracked so they can effectively manage homework and partner with the child’s family to extend learning beyond the classroom."
      },
      {
        "featureTitle": "Find and Share",
        "featureDescription": "Why recreate the wheel? Choose from over 60,000 FREE ready-made print and interactive activities and 1,100 categorized public groups in the Boardmaker Community - the largest sharing community of its kind in the world. You can also upload activities you've created to your Boardmaker Community account and share them with parents, therapists, or your learner's support team."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Cost savings",
        "advantagePoints": [
          "Exclusive customized organization packages for 5+ accounts",
          "Cloud-based services allow for easy reassignment of licenses as staff transaction",
          "Volume Pricing",
          "Multi-product bundles",
          "Multi-year savings"
        ]
      },
      {
        "advantageTitle": "Success for all",
        "advantagePoints": [
          "Research-based and ready-made activities ensure positive, measurable outcomes",
          "Following the principals of Universal Design for Learning, our Adapted Educational Materials and activities make learning goals achievable by individuals with various abilities",
          "Adapted curricula provides equal access for all",
          "Resources available to encapsulate expert best practices ensuring that you get the most out of your solutions"
        ]
      },
      {
        "advantageTitle": "Supports standards and requirements",
        "advantagePoints": [
          "Solutions designed specifically to teach and measure progress towards college and career readiness standards",
          "Wide array of solutions that support Universal Design for Learning, Every Child Succeeds and the Individuals with Disabilities Education Act requirements",
          "track and report on progress towards Individual Education Plan goals automatically through data dashboards"
        ]
      },
      {
        "advantageTitle": "Easy organization deployment",
        "advantagePoints": [
          "Empowers administrators to deliver and deploy accounts remotely within seconds",
          "Flexible and scalable organization deployment options",
          "All cloud-based solutions are hosted in a highly secured tier-1 data center",
          "Free automatic cloud-based updates with new exciting features and resources"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 or later"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 or later"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 or later"]
      ],
      "browser": [
        ["Chrome", "v49.0", "current"],
        ["Firefox", "v38.0", "current"],
        ["Safari", "v11.0", "current"],
        ["Edge", "v83.0.478.45", "current"],
        ["Internet Explorer", "v10.0", "v11.0 or later"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "The next generation of Boardmaker software has arrived!  Boardmaker 7 takes the best features of all previous versions of Boardmaker and rolls them into one multi-platform, multi-language app.  Boardmaker 7 features a streamlined user interface that positions the tools you need at your fingertips.  It includes the latest PCS symbols, yet it’s backward compatible with all your old boards and activities. This new software will allow you to create and deliver adapted curriculum and communication supports faster than ever before.",
    "topReasons": {
      "header": "Top reasons to buy Boardmaker 7 software",
      "points": [
        "Edit, print, and play all your old Boardmaker files",
        "Intuitive, modern interface with built-in hints and training materials",
        "Awesome templates that are fast and easy to customize",
        "Quickly find the symbols and pictures you need"
      ]
    },
    "summaryEnd": "Download your free 30 day trial today!",
    "features": [
      {
        "featureTitle": "Opens Everything You’ve Made",
        "featureDescription": "Don’t waste all your years of hard work…  with Boardmaker 7 software you can open any file created with Boardmaker v5, Boardmaker v6, or Boardmaker Studio.  Conversion is fast and accurate, so even complex interactive activities will work and look just like the original."
      },
      {
        "featureTitle": "Easy, Easy, Easy",
        "featureDescription": "The users have spoken!  Informed by extensive user testing with people just like you, the Boardmaker 7 software interface is modern, welcoming, and intuitive.  The built-in hints and training materials give you the confidence to explore, expand your skills and, most importantly, support your students."
      },
      {
        "featureTitle": "Fast / Saves Time",
        "featureDescription": "With redesigned templates for both print and interactive activities, you’ll be amazed at the breadth and depth of what you can accomplish in just a few minutes.  You’ll be done with that schedule or social story in no time, freeing your attention for the students you serve.  Boardmaker also makes it easy to customize what you’ve created, so you’ve got the ideal combination of speed and flexibility."
      },
      {
        "featureTitle": "Superior Symbol Search",
        "featureDescription": "Symbols are who we are. Boardmaker 7 boasts improved symbol search functionality and an intuitive way to browse symbols by category… but that’s just the start.  You can search for portions of words, rhyming words, individual phonemes, and consonant/vowel patterns. This is the most powerful search tool available!  And just in case you can’t find that special symbol, the integrated web search and camera tools enable you to add photos quickly and easily."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 or later"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 or later"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 or later"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 or later"],
        ["Android", "Tobii Dynavox T-Series Devices", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I-15"
        ]
      ]
    }
  }
}
